@if (formService.isFormLoaded()) {
	<sim-labelled-container label="LABEL_FILTER" icon="fa-filter" class="mat-elevation-z4">
		<div class="scrollViewport outer" role="region">
			@for (col of searchableColumns(); track col.displayName) {
				<div class="searchItem">
					@switch (col.type) {
						@case ("FreeText") {
							<mat-form-field color="accent" class="full-width-form">
								<mat-label>{{ col.displayName | translate }}</mat-label>
								<input
									[formControl]="$any(formGroup.get(col.value))"
									matInput
									[placeholder]="col.displayName | translate"
								/>

								@if (formService.formGroup.controls[col.value]?.value) {
									<button
										color="warn"
										[@zoomInOnEnter]
										matSuffix
										mat-icon-button
										aria-label="Clear"
										(click)="formService.clearFilter(col)"
									>
										<mat-icon fontSet="fas" fontIcon="fa-times-circle" inline />
									</button>
								}
							</mat-form-field>
						}
						@case ("Date") {
							<mat-form-field color="accent" class="full-width-form">
								<mat-label>{{ col.displayName | translate }}</mat-label>
								<input
									[formControl]="$any(formGroup.get(col.value))"
									(click)="picker.open()"
									(focusin)="picker.open()"
									matInput
									[matDatepicker]="picker"
								/>
								<mat-datepicker-toggle matSuffix [for]="picker" />
								<mat-datepicker #picker />
							</mat-form-field>
						}
						@case ("Checkbox") {
							<mat-checkbox style="margin-left: 12px" [formControl]="$any(formGroup.get(col.value))">
								{{ col.displayName | translate }}
							</mat-checkbox>
						}
						@case ("Select") {
							@if (TypePredicates.isSelectColumn(col)) {
								<mat-form-field color="accent" class="full-width-form">
									<mat-select [formControl]="$any(formGroup.get(col.value))" [placeholder]="col.displayName | translate">
										@for (option of col.selectableOptions; track option.value) {
											<mat-option [value]="option.value">{{ option.translationToken | translate }}</mat-option>
										}
										<mat-option [value]="null">{{ T.GLOBAL_TXT_CLEAR | translate }}</mat-option>
									</mat-select>
								</mat-form-field>
							}
						}
						@case ("MultiSelect") {
							@if (TypePredicates.isMultiSelectColumn(col)) {
								<div class="full-width-form">
									<mat-form-field color="accent" class="full-width-form">
										<mat-select
											#matSelect
											(selectionChange)="addMultiselectEntry(col, $event, matSelect)"
											[placeholder]="col.displayName | translate"
										>
											@for (option of col.selectableOptions; track option.value) {
												<mat-option [value]="option.value">{{ option.translationToken | translate }}</mat-option>
											}
										</mat-select>
									</mat-form-field>

									@if ($any(formGroup.get(col.value))?.value?.length) {
										<div class="multiSelectList">
											<div class="scrollViewport">
												@for (multiSelectValue of $any(formGroup.get(col.value)).value; track multiSelectValue) {
													<sim-list-item
														[primaryLabel]="
															(findMultiselectValue | wrapFn: col.selectableOptions : multiSelectValue)
																?.translationToken
														"
														[indicator]="{fontIcon: col.icon, fontSet: 'fas'}"
														[selectable]="false"
													>
														<ng-container actions>
															<button
																mat-icon-button
																color="warn"
																(click)="removeMultiSelectEntry(col, multiSelectValue)"
															>
																<mat-icon fontIcon="fa-times" fontSet="fa" />
															</button>
														</ng-container>
													</sim-list-item>
												}
											</div>
										</div>
									}
								</div>
							}
						}
						@case ("User") {
							<sim-chip-autocomplete
								class="full-width-form"
								[id]="col.value"
								[dataType]="FetchDataType.SimUser"
								[formCtrl]="$any(formGroup.get(col.value))"
								[labelToken]="col.displayName"
							>
								<mat-icon labelPrefix fontIcon="fa-user-md" fontSet="fa" />
							</sim-chip-autocomplete>
						}
						@case ("Event") {
							<sim-chip-autocomplete
								class="full-width-form"
								[id]="col.value"
								[dataType]="FetchDataType.Event"
								[formCtrl]="$any(formGroup.get(col.value))"
								[labelToken]="col.displayName"
							>
								<mat-icon labelPrefix fontIcon="fa-calendar" fontSet="fa" />
							</sim-chip-autocomplete>
						}
					}
				</div>
			}
		</div>

		<div class="actionsWrapper">
			@let config = filterActions();
			@if (config.download.state === "enabled" || config.download.state === "disabled") {
				<sim-button
					color="accent"
					(onClick)="executeFilterAction(config.download.action)"
					[disabled]="config.download.state === 'disabled'"
					[label]="T.ASSESSMENT_EXPORT_ALL"
					[icon]="{
						fontSet: 'fad',
						fontIcon: 'fa-download',
					}"
				/>
			}

			<sim-button
				(onClick)="formService.clearAllFilters(searchableColumns())"
				[icon]="{
					fontSet: 'fad',
					fontIcon: 'fa-history',
				}"
				[label]="T.ASSESSMENT_CLEAR_SELECTION"
				color="warn"
			/>
		</div>
	</sim-labelled-container>
}
